var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-cookie"},[(_vm.size==='small')?_c('CookieSmall'):(_vm.size==='large')?_c('CookieLarge'):_c('CookieMedium')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }